import { border } from "../../UI/tokens";
import styled from 'styled-components';

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 8px;
  background-color: ${({ theme }) => (theme.bg3)};
  border-radius: 3px;
  padding: 8px;
  min-width: 250px;
  flex: 1;

  @media (max-width: 768px) {
    margin: 8px 0;
  }

border-radius: 12px; border: 1px solid ${border}; padding: 16px;
`;

export const ColumnTitle = styled.h2`
  margin: 0;
  padding-bottom: 8px;
  font-size: 1.2rem;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

font-size: 14px; font-weight: 700; padding-bottom: 16px;
`;
